import ProdModel from '@/models/Prod';
import MemModel from '@/models/Mem';

const GET_COLLECT_PAGING_LIST = 'GET_COLLECT_PAGING_LIST';
const GET_FOOTPRINT = 'GET_FOOTPRINT';

/**
 * 获取收藏列表(分页)
 */
async function getCollectPagingList(params) {
  const payload = await new ProdModel().getCollectPagingList(params);
  return {
    type: GET_COLLECT_PAGING_LIST,
    payload
  }
}

/**
 * 获取足迹信息
 */
async function getFootprint(params) {
  const payload = await new MemModel().getFootprint(params);
  return {
    type: GET_FOOTPRINT,
    payload
  }
}

const ACTION_TYPES = {
  GET_COLLECT_PAGING_LIST,
  GET_FOOTPRINT,
};

const ACTION = {
  getCollectPagingList,
  getFootprint,
};

const CollectList = {
  ACTION_TYPES,
  ACTION
}

export default CollectList;